import LaunchPad from "views/LaunchPad";

export default LaunchPad